import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReduxState } from "../../reducers";
import {
  sendMfaEnrollCode,
  confirmMfaEnroll,
} from "../../actions/login.action";
import { getRecaptchaVerifier } from "../../firebase/firebaseUtils";

interface MfaEnrollProps {
  onComplete: () => void;
  onSkip: () => void;
}

export default function MfaEnroll({ onComplete, onSkip }: MfaEnrollProps) {
  const storeDispatch = useDispatch();
  const mfa = useSelector((state: ReduxState) => state.login.mfa);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [step, setStep] = useState<"phone" | "otp">("phone");

  useEffect(() => {
    if ((window as any).recaptchaVerifier) {
      (window as any).recaptchaVerifier.clear();
    }
    const verifier = getRecaptchaVerifier("mfa-recaptcha");
    (window as any).recaptchaVerifier = verifier;
    return () => {
      try { verifier.clear(); } catch (_) {}
      delete (window as any).recaptchaVerifier;
    };
  }, []);

  async function handleSendCode() {
    const phone = phoneNumber.startsWith("+") ? phoneNumber : "+" + phoneNumber;
    const verifier = (window as any).recaptchaVerifier;
    if (!verifier) return;
    const vId = await sendMfaEnrollCode(phone, verifier, storeDispatch);
    if (vId) setStep("otp");
  }

  async function handleVerify() {
    const success = await confirmMfaEnroll(mfa.verificationId, otp, "Phone", storeDispatch);
    if (success) onComplete();
  }

  return (
    <div className="auth-wrapper">
      <div className="auth-card">
        <h5 className="subheading fs-14 mb-4 text-center">
          Set up Multi-Factor Authentication
        </h5>
        <div id="mfa-recaptcha" />
        {step === "phone" && (
          <div>
            <div className="form-signin-label-group">
              <input
                type="tel"
                className="form-control input-login"
                placeholder="Phone number with country code"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
              <label>Phone number (e.g. +919876543210)</label>
            </div>
            {mfa.error && (
              <div className="login-error-text text-center mb-3">{mfa.error}</div>
            )}
            <button
              className="btn btn2 d-block w-100"
              onClick={handleSendCode}
              disabled={mfa.enrolling || !phoneNumber}
            >
              {mfa.enrolling ? "Sending code..." : "Send Code"}
            </button>
            <div className="text-center mt-3">
              <button
                className="btn btn-link primarycolor font-size-small"
                onClick={onSkip}
              >
                Skip for now
              </button>
            </div>
          </div>
        )}
        {step === "otp" && (
          <div>
            <div className="form-signin-label-group">
              <input
                type="text"
                className="form-control input-login"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
              />
              <label>OTP sent to your phone</label>
            </div>
            {mfa.error && (
              <div className="login-error-text text-center mb-3">{mfa.error}</div>
            )}
            <button
              className="btn btn2 d-block w-100"
              onClick={handleVerify}
              disabled={mfa.verifying || !otp}
            >
              {mfa.verifying ? "Verifying..." : "Verify & Enroll"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
